import { QuestionType } from '~src/graphql';

export const options = Object.values(QuestionType).map((type) => ({
  name: type.toLowerCase()
    .replace(/[^a-zA-Z0-9 ]/g, ' ')
    .replace(/\s_/g, '_'),
  value: type,
}));
